// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__YkIyo","actions":"GroupTable_actions__3dXKg","deleteModalFooter":"GroupTable_deleteModalFooter__1B-NY"};